import React from "react"
import styled from "styled-components"

import { TextInput, Checkbox } from "../../atoms/inputs"
import { Grid } from "../../atoms/grid"

import { navigate } from "gatsby"

import App from "../../../firebase"

import ReCAPTCHA from "react-google-recaptcha"

import { Button } from "../../atoms/buttons"
import { Settings } from "../../../styles/theme"
import Select from "react-select"

import { saveAs } from "file-saver"
import * as JSZip from "jszip"
import * as JSZipUtils from "jszip-utils"

import axios from "axios"

const Formstyle = styled.div`
  position: relative;
  .calc {
    h4 {
      color: #000;
      opacity: 1;
    }
  }
  .select {
    padding: 0 5px;
    p,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    div {
      text-transform: capitalize;
    }
    div {
      padding: 0.5px;
    }
    > div {
      font-family: "Poppins", "Helvetica", sans-serif !important;
      > div {
        font-size: 0.9rem;
      }
    }
  }
`
function camelize(str) {
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index == 0 ? word.toLowerCase() : word.toUpperCase()
    })
    .replace(/\s+/g, "")
}

export class FormCluster extends React.Component {
  constructor(props) {
    super(props)
    let obj = this.props.data.cluster
    let objects = {}
    obj.map(k => {
      objects[camelize(k.title)] = {
        validated: false,
        value: "",
        required: k.required === false ? k.required : true,
      }
    })
    let sub = this.props.data.subCluster
    if (sub === undefined) {
      sub = []
    }
    let subCluster = {}
    sub.map(k => {
      subCluster[camelize(k.title)] = {
        validated: false,
        value: "",
        required: k.required === false ? k.required : true,
      }
    })
    let ck = this.props.data.checks
    let checks = {}
    ck.map(k => {
      checks[k.title] = {
        validated: false,
        value: false,
        required: k.required === false ? k.required : true,
      }
    })
    const email = this.props.data.email
    this.state = {
      form: objects,
      subForm: subCluster,
      privacy: checks,
      formName: this.props.data.formName,
      valid: false,
      attempted: false,
      captcha: false,
      email: email,
    }
  }

  handleChange = e => {
    const value = e.target.value
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: { ...this.state.form[e.target.name], value: value },
      },
    })
  }

  handleDropdown = (selectedOption, options) => {
    const name = options.name
    const value = selectedOption.value
    this.setState({
      form: {
        ...this.state.form,
        [name]: { ...this.state.form[name], value: value },
      },
    })
  }

  handleChangeSub = e => {
    const value = e.target.value
    this.setState({
      subForm: {
        ...this.state.subForm,
        [e.target.name]: { ...this.state.subForm[e.target.name], value: value },
      },
    })
  }

  downloadZip = () => {
    const zip = new JSZip()
    let count = 0
    const zipFilename = "SA2020-Downloads.zip"
    const urls = this.props.downloads

    urls.forEach(function(url) {
      JSZipUtils.getBinaryContent(url, function(err, data) {
        if (err) {
          throw err
        }
        zip.file(/([^/]*)$/.exec(url)[0], data, { binary: true })
        count++
        if (count == urls.length) {
          zip.generateAsync({ type: "blob" }).then(function(content) {
            saveAs(content, zipFilename)
            navigate("/thank-you-downloads")
          })
        }
      })
    })
  }

  sendMail = (email, from, subject, data) => {
    const url =
      "https://us-central1-airshow-droplet.cloudfunctions.net/sendgridFunction"
    const dataSet = Object.keys(data).map(function(key) {
      return "<p><b>" + key + ":</b>" + data[key].value + "</p>"
    })
    axios
      .get(url, {
        params: {
          from: from,
          subject: subject,
          email: email,
          html: "<div>" + dataSet.join("") + "</div>",
        },
      })
      .then(function(response) {
        navigate("/thank-you")
      })
      .catch(function(error) {
        console.log(error)
      })
  }

  dbSave = () => {
    let downloads = this.props.downloads
    if (downloads === undefined) {
      downloads = []
    }
    const subStates = this.state.subForm
    const states = this.state.form
    const email = this.state.email
    const privacy = this.state.privacy
    const dateTime = { date: { value: new Date() } }
    const combined = {
      ...subStates,
      ...states,
      ...privacy,
      ...dateTime,
    }
    const emailAddress = combined["emailAddress"]
      ? combined["emailAddress"].value
      : combined["businessEmail"].value
    App.firestore()
      .collection(this.state.formName)
      .doc(emailAddress)
      .set(combined)
      .then(
        email
          ? this.sendMail(
              "sales2020@singaporeairshow.com",
              "sales2020@singaporeairshow.com",
              this.state.formName,
              combined
            )
          : downloads.length !== 0
          ? this.downloadZip()
          : navigate("/thank-you")
      )
      .catch(error => alert(error))
  }

  validate = () => {
    let form = this.state.form
    let valid = true
    Object.keys(form).map(key => {
      const value = form[key].value
      const required = form[key].required
      if (required && value === "") {
        form[key].validated = false
        valid = false
      } else {
        form[key].validated = true
      }
    })

    let privacy = this.state.privacy
    if (privacy === undefined) {
      privacy = []
    }
    Object.keys(privacy).map(key => {
      const value = privacy[key].value
      const required = privacy[key].required
      if (required && value !== true) {
        privacy[key].validated = false
        valid = false
      } else {
        privacy[key].validated = true
      }
    })

    let subForm = this.state.subForm
    if (subForm === undefined) {
      subForm = []
    }
    if (
      (Object.keys(subForm).length === 0 && subForm.constructor === Object) !==
      true
    ) {
      Object.keys(subForm).map(key => {
        const value = subForm[key].value
        const required = subForm[key].required
        if (required && value === "") {
          subForm[key].validated = false
          if (!subForm[key].title === "scheme") {
            valid = false
          }
        } else {
          subForm[key].validated = true
        }
      })
    }

    if (
      (Object.keys(subForm).length === 0 && subForm.constructor === Object) !==
      true
    ) {
      let minSpace = 36
      if (subForm.scheme.value === "Standard Shell Scheme") {
        minSpace = 12
      }
      if (minSpace > subForm.length.value * subForm.width.value) {
        valid = false
      }
    }

    this.setState(
      {
        attempted: true,
        valid: valid,
        form: form,
        subForm: subForm,
      },
      this.submit(valid)
    )
  }

  submit = valid => {
    valid && this.state.captcha === true
      ? this.dbSave()
      : console.log(this.state)
  }

  handleSubmit = e => {
    this.validate()
  }

  handleCaptcha = () => {
    this.setState({
      captcha: true,
    })
  }

  handleChecks = name => {
    this.setState({
      privacy: {
        ...this.state.privacy,
        [name]: {
          ...this.state.privacy[name],
          value: !this.state.privacy[name].value,
        },
      },
    })
  }

  handleRadio = (name, value) => {
    this.setState({
      subForm: {
        ...this.state.subForm,
        [name]: {
          ...this.state.subForm[name],
          value: value,
        },
      },
    })
  }

  render() {
    return (
      <Formstyle>
        <div className="constraint">
          {this.props.data.subName ? (
            <div>
              <h4 style={{ fontWeight: "700", opacity: "0.4" }}>
                {this.props.data.subName}
              </h4>
              <Grid columns={1}>
                {this.props.data.subCluster[2].options.map((option, k) => (
                  <div style={{ marginTop: "1rem" }} key={k}>
                    <Grid columns={2}>
                      <div>
                        <Grid>
                          <div
                            onClick={() => this.handleRadio("scheme", option)}
                          >
                            <input
                              type="radio"
                              name="scheme"
                              style={{ display: "inline" }}
                              checked={
                                this.state.subForm.scheme.value === option
                              }
                            />
                            <p style={{ display: "inline" }}>{option}</p>
                          </div>
                          <div>
                            <p>My Preferred Size</p>
                          </div>
                        </Grid>
                      </div>
                      <Grid unstack>
                        {this.props.data.subCluster.map((ele, i) => {
                          return !ele.type ? (
                            <div key={i}>
                              <Grid unstack>
                                <div>
                                  <TextInput
                                    placeholder={ele.title}
                                    name={camelize(ele.title)}
                                    width={ele.width}
                                    callback={this.handleChangeSub}
                                    disabled={
                                      this.state.subForm.scheme.value !== option
                                        ? true
                                        : false
                                    }
                                    validation={
                                      ele.validation ? ele.validation : "text"
                                    }
                                    value={
                                      this.state.subForm.scheme.value !== option
                                        ? 0
                                        : this.state.subForm[
                                            camelize(ele.title)
                                          ].value
                                    }
                                    valid={
                                      this.state.attempted === false ||
                                      this.state.subForm[camelize(ele.title)]
                                        .validated
                                        ? true
                                        : false
                                    }
                                    key={i}
                                  />
                                </div>
                                <div>
                                  <p>
                                    m{" "}
                                    {i === 1 ? (
                                      " (min " + ele.minSpace[k] + "Sqm)"
                                    ) : (
                                      <span style={{ marginLeft: "3rem" }}>
                                        x
                                      </span>
                                    )}
                                  </p>
                                </div>
                              </Grid>
                            </div>
                          ) : (
                            ""
                          )
                        })}
                      </Grid>
                    </Grid>
                  </div>
                ))}
              </Grid>
              <Grid unstack>
                 
                <div style={{ flex: "1 1 20%" }} />
                <div style={{ flex: "1 1 20%" }} className="calc">
                  <h4
                    style={{
                      color:
                        this.state.subForm.scheme.value ===
                        "Standard Shell Scheme"
                          ? 12 >
                            this.state.subForm.length.value *
                              this.state.subForm.width.value
                            ? "red"
                            : ""
                          : 36 >
                            this.state.subForm.length.value *
                              this.state.subForm.width.value
                          ? "red"
                          : "",
                    }}
                  >
                    Total Sqm:
                  </h4>
                  <h4>Registration Fee:</h4>
                  <h4 style={{ color: Settings.primaryColor }}>
                    <b>Total Participation Fee:</b>
                  </h4>
                </div>
                <div style={{ flex: "1 1 45%" }} className="calc">
                  <h4
                    style={{
                      color:
                        this.state.subForm.scheme.value ===
                        "Standard Shell Scheme"
                          ? 12 >
                            this.state.subForm.length.value *
                              this.state.subForm.width.value
                            ? "red"
                            : ""
                          : 36 >
                            this.state.subForm.length.value *
                              this.state.subForm.width.value
                          ? "red"
                          : "",
                    }}
                  >
                    {" "}
                    {this.state.subForm.length.value *
                      this.state.subForm.width.value}{" "}
                    Sqm{" "}
                    {this.state.subForm.scheme.value === "Standard Shell Scheme"
                      ? 12 >
                        this.state.subForm.length.value *
                          this.state.subForm.width.value
                        ? "(Insufficient Space)"
                        : ""
                      : 36 >
                        this.state.subForm.length.value *
                          this.state.subForm.width.value
                      ? "(Insufficient Space)"
                      : ""}
                  </h4>
                  <h4>$1000</h4>
                  <h4 style={{ color: Settings.primaryColor }}>
                    <b>
                      $
                      {this.state.subForm.length.value *
                        this.state.subForm.width.value *
                        (this.state.subForm.scheme.value ===
                        "Standard Shell Scheme"
                          ? 1700
                          : 1550) +
                        1000}
                    </b>
                  </h4>
                </div>
              </Grid>
            </div>
          ) : (
            ""
          )}
          <h4 style={{ fontWeight: "700", opacity: "0.4" }}>
            {this.props.data.clusterName}
          </h4>
          <Grid>
            {this.props.data.cluster.map((ele, i) =>
              ele.type === "dropdown" ? (
                <Select
                  value={
                    this.state.form[camelize(ele.title)].value !== ""
                      ? {
                          value: this.state.form[camelize(ele.title)].value,
                          label: this.state.form[camelize(ele.title)].value,
                        }
                      : null
                  }
                  onChange={this.handleDropdown}
                  placeholder={ele.title}
                  name={camelize(ele.title)}
                  className="select"
                  options={ele.options}
                  styles={{
                    control: provided => ({
                      ...provided,
                      borderRadius: 0,
                      border:
                        this.state.attempted === false ||
                        this.state.form[camelize(ele.title)].validated
                          ? "2px solid rgba(0,0,0,0.6)"
                          : "2px solid red",
                      minHeight: 0,
                    }),
                    container: () => ({
                      // none of react-select's styles are passed to <Control />
                      flex: "1 1 " + ele.width + "% !important",
                      position: "relative",
                      borderRadius: 0,
                    }),
                    valueContainer: provided => ({
                      ...provided,
                      padding: 0,
                    }),
                    indicatorContainer: provided => ({
                      ...provided,
                      padding: 0,
                    }),
                    placeholder: provided => ({
                      ...provided,
                      fontSize: "0.7rem",
                    }),
                  }}
                />
              ) : (
                <TextInput
                  placeholder={ele.title}
                  name={camelize(ele.title)}
                  width={ele.width}
                  callback={this.handleChange}
                  validation={ele.validation ? ele.validation : "text"}
                  valid={
                    this.state.attempted === false ||
                    this.state.form[camelize(ele.title)].validated
                      ? true
                      : false
                  }
                  key={i}
                />
              )
            )}
          </Grid>
          <div>
            {this.props.data.checks.map((ele, i) => (
              <Checkbox
                key={i}
                data={ele}
                callback={this.handleChecks}
                state={this.state.privacy[ele.title].value}
              />
            ))}
          </div>
          <ReCAPTCHA
            sitekey="6LdV-78UAAAAAMDlVWqvaefz--Y_hoevrl_1t0t3"
            onChange={this.handleCaptcha}
          />
          <div style={{ padding: "2rem 0" }}>
            <Button onClick={this.handleSubmit} type="solid">
              {this.props.data.submission
                ? this.props.data.submission
                : "Submit"}
            </Button>
          </div>
        </div>
      </Formstyle>
    )
  }
}
